import React, { useEffect, useState } from "react";
import Editor from "../../../elements/tiptap-editor/Editor";
import useForm from "../../../../hooks/useForm";
import Button from "../../../form/Button";
import { postAddEdit } from "../../../../services/postService";
import { useMutation } from "@tanstack/react-query";
import Input from "../../../form/Input";
import { toast } from "react-toastify";
import { taxonomyList } from "../../../../services/taxonomyService";
import SelectSingleImage from "../../../form/SelectSingleImage";
import { generateSlug, supportedLanguages, userLang } from "../../../../helpers";
import LanguageTabs from "../../../elements/LanguageSwitcher";

const validation = {
  title: { required: true, message: "Title is required" },
  // content: { required: true, message: "Answer is required" },
};

const ManageTestimonial = ({ getResponse = () => {}, close = () => {}, data }) => {
  const [testimonialImage, setTestimonialImage] = useState([]);
  const { values, handleChange, handleSubmit, errors, setFieldsValue, resetField, formValidate } = useForm({
    validationRules: validation,
  });
  const [currentLang, setCurrentLang] = useState(userLang || "en");
  const handleLangChange = (lang) => {
    setCurrentLang(lang);
  };

  useEffect(() => {
    if (data?._id) {
      setFieldsValue({
        ...data,
        content: {
          ...supportedLanguages.reduce((acc, lang) => {
            acc[lang.code] = {
              title: data?.content?.[lang.code]?.title || "",
              subTitle: data?.content?.[lang.code]?.subTitle || "",
              content: data?.content?.[lang.code]?.content || "",
              seo: data?.content?.[lang.code]?.seo || {},
            };
            return acc;
          }, {}),
        },
        title: data?.content?.[currentLang]?.title || "",
      });
      setTestimonialImage(data?.mediaGallery?.[0] || []);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data]);

  const {
    mutate,
    error,
    isLoading: detailsLoading,
    isPending: isLoading,
  } = useMutation({
    mutationFn: async (val) => {
      return await postAddEdit({
        ...val,
        type: "testimonial",
        slug: `${generateSlug(val?.content?.[userLang]?.title.replace(/\s+/g, "-").toLowerCase(), Date.now())}`,
        lang: localStorage.getItem("lang"),
        mediaGallery: [testimonialImage?._id] || [],
        ...(data?._id && { id: data?._id }),
      });
    },
    onSuccess: (res) => {
      getResponse(res);
      return res;
    },
    onError: (error) => {
      console.log(error);
    },
  });

  return (
    <form onSubmit={(event) => handleSubmit(event, mutate)}>
      <LanguageTabs languages={supportedLanguages} value={currentLang} onChange={handleLangChange} />
      <div className="grid grid-cols-4 gap-x-4 gap-y-4 m-4">
        <div className="relative col-span-3">
          <Input
            label="Title"
            inputPlaceholder="title"
            inputType={"title"}
            inputName={`content.${currentLang}.title`}
            value={values?.content?.[currentLang]?.title || ""}
            onChange={(e) => {
              const newValue = e.target.value;
              setFieldsValue({
                ...values,
                title: newValue,
                content: {
                  ...values.content,
                  [currentLang]: {
                    ...values.content?.[currentLang],
                    title: newValue,
                  },
                },
              });
            }}
            {...formValidate(errors, "title")}
          />
        </div>
        {/* <div className="relative col-span-1">
          <div className=" rounded-lg p-2 space-y-2 justify-end">
            <SelectSingleImage
              label="Upload Image"
              size="md"
              value={testimonialImage}
              onChange={(img) => setTestimonialImage(img)}
              onRemove={() => setTestimonialImage(null)}
            />
          </div>
        </div> */}
        <div className="col-span-1 space-y-6">
          <div className="border border-gray-300 rounded-lg p-2 space-y-2">
            <SelectSingleImage
              label="Upload Image"
              size="md"
              value={testimonialImage}
              onChange={(img) => setTestimonialImage(img)}
              onRemove={() => setTestimonialImage(null)}
            />
          </div>
        </div>

        <div className="relative col-span-4">
          <Editor
            label="Content"
            // placeholder="content"
            // value={values?.content}
            // onChange={(val) =>
            //   handleChange({
            //     target: { name: "content", value: val },
            //   })
            // }
            // {...formValidate(errors, "content")}
            height={200}
            placeholder={"content"}
            value={values?.content?.[currentLang]?.content || ""}
            onChange={(val) => {
              setFieldsValue({
                ...values,
                content: {
                  ...values.content,
                  [currentLang]: {
                    ...values.content?.[currentLang],
                    content: val,
                  },
                },
              });
            }}
          />
        </div>
      </div>
      <div className="pt-3 p-6 flex justify-end">
        <Button
          buttonType="submit"
          buttonClasses={"min-w-36"}
          buttonLabel={data?._id ? "Update" : "Save"}
          {...((isLoading || detailsLoading) && {
            loading: true,
            buttonIconPosition: "left",
            isDisable: true,
          })}
        />
      </div>
    </form>
  );
};

export default ManageTestimonial;
